/**
 * Wrapper widget for CA UI Kit form validations
 */
(function($) {
  var alertDiv = 'div.inline-error';
  var errorClass = 'ca-ui-alert flex align-items-center ca-ui-bg-danger inline-error';
  var iconElement = '<i class="ca-ui-i ca-ui-i-sm ca-ui-i-alert"></i>';
  var inputContainer = '.ca-ui-text-input';
  var inputErrorBorder = 'error';

  $.widget('caUi.validateForm', {
    options: {
      showErrors: function(errorMap, errorList) {
        if (errorList.length < 1) {
          $(alertDiv).remove();
          $(inputContainer).removeClass(inputErrorBorder);
        } else {
          $.each(errorList, function(index, error) {
            var inputLabel = 'label[for="' + error.element.id + '"]';

            $(inputLabel).next(alertDiv).remove();
            $(error.element).closest(inputContainer).removeClass(inputErrorBorder);
            $(inputLabel).after(
              $('<div>')
                .addClass(errorClass)
                .append(iconElement)
                .append(error.message)
            );
            $(error.element).closest(inputContainer).addClass(inputErrorBorder);
          });
        }
      },
      onkeyup: false,
      rules: {},
      messages: {},
      submitHandler: function() {
        return false;
      }
    },

    _create: function() {
      this.element.validate({
        showErrors: this.options.showErrors,
        onkeyup: this.options.onkeyup,
        rules: this.options.rules,
        messages: this.options.messages,
        submitHandler: this.options.submitHandler
      })
    }
  })
})(jQuery);